const KEY = "dh_event_draft";

export function saveEventDraft(agentId, form) {
  localStorage.setItem(`${KEY}:${agentId || "default"}`, JSON.stringify(form || {}));
}

export function loadEventDraft(agentId) {
  try {
    return JSON.parse(localStorage.getItem(`${KEY}:${agentId || "default"}`) || "null");
  } catch {
    return null;
  }
}
